import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import EventEmitter from '../../utils/events'

import ExtentAdapter from './ExtentAdapter'
// import {
//   FILE_STORAGE
// } from '../../constants'

// Actions
import { updateOtherOrderPrice, setCarParts, setCarSelectedParts } from '../../actions/price'
import { getPriceInformations, getPriceInformation } from '../../actions/priceModel'
import { updatePrices } from '../../actions/orderPrice'
import { getOrder, getRejectedEvaluations } from '../../actions/orders'
import { saveBookingTime } from '../../actions/bookingTime'
import { triggerPopup } from '../../actions/backdrop'
import { getCustomer } from '../../actions/customers'

// import styles
import './pricecalculation.scss'

// import components
import Header from '../../shared/components/Header'
import Car from '../../shared/components/Car'
// import Price from './Price'

import Extent from '../../shared/components/Extent'

// import Gallery from '../../shared/components/Gallery'
// import HelpText from '../../shared/components/HelpText'
import Evaluation from '../../shared/components/Evaluation'

// import modals
import CarsizeModal from '../../shared/modals/CarsizeModal'
import DeliveryDateChangeModal from '../../shared/modals/DeliveryDateChangeModal'
import Confirm from '../../shared/components/Confirm'

// Utils
import { hasAccess, hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../utils/auth'
import { makeOrderPageTitleObject } from '../../utils/order'
import { setPageTitle } from '../../actions/common'
import { renderTimeOnly } from '../../utils/time'
// import { renderFullDate } from '../../utils/time'
import { formatCurrency, reverseFormatCurrency } from '../../utils/currency'
import { shouldHaveArrow } from '../../utils/router'
import { translation } from '../../utils/helpers'
import { ElementIcons, CarIcons } from '../../shared/elements/icons'
import {BookingTimesSectionType} from '../../constants'

// Elements
import Button from '../../shared/elements/button'
import Textarea from '../../shared/elements/textarea'
import Text from '../../shared/elements/text'
import DropDown from '../../shared/elements/dropDown'
import Panel from '../../shared/elements/panel'
import Row from '../../shared/elements/row'
import Col from '../../shared/elements/col'
import HeaderElement from '../../shared/elements/panelHeader'
import Icon from '../../shared/elements/icon'
import Grid from '../../shared/elements/grid'
import CloseButton from '../../shared/elements/closeButton'
import BackButton from '../../shared/elements/backButton'
// import Divider from '../../shared/elements/divider'

class PriceCalculation extends Component {

  constructor (props) {
    super(props)

    this.state = {
      manualPriceChanged: false,
      isUpdating: false,
      price: {},
      helperPopup: false,
      view: 'euro',
      carswitcher: false,
      car: {
        bodyParts: [],
        parts: [],
        extents: [],
        services: [],
        extra: [],
        mapping: {},
        complaints: [],
        reasons: {},
        otherDamages: [],
        final: {
          bodyParts: [],
          parts: [],
          extra: [],
          services: [],
          addon: [],
          addonStartTimes: []
        }
      },
      eventListener: undefined,
      customer_price: {
        gross_reduced: 'discount',
        discount: 0,
        netprice: 0
      },
      activeTaskId: 0,
      manual: {
        Price: 0,
        Environment: 0,
        OtherDescription: '',
        OtherTitle: ''
      },
      contacts: [],
      rejections: [],
      showEmail: false,
      draftDeliveryChangePopup: {
        show: false,
        originalDate: '',
        oldDate: '',
        newDate: '',
        changedFromPopup: false
      },
      deliveryTime: '',
      ShowExitConfirm: false,
      ShowExitConfirmClose: false,
      dimensions: {
        width: 0,
        height: 0
      },
      SelectedContact: '0',
      SelectedContactMail: ''
    }
    this.openEmail = this.openEmail.bind(this)
    this.getNewPriceCalc = this.getNewPriceCalc.bind(this)
    this.extentAdapterEventHandler = this.extentAdapterEventHandler.bind(this)
    this.bindCarEvent = this.bindCarEvent.bind(this)
    this.bindCarEventBooked = this.bindCarEventBooked.bind(this)
    this.bindCarEventNoItems = this.bindCarEventNoItems.bind(this)
    this.bindCarBodyEvent = this.bindCarBodyEvent.bind(this)
    this.setactiveitem = this.setactiveitem.bind(this)
    this.initData = this.initData.bind(this)
    this.clearEvents = this.clearEvents.bind(this)
    this.setManualPrice = this.setManualPrice.bind(this)
    this.renderDraftDeliveryDatePopup = this.renderDraftDeliveryDatePopup.bind(this)
    this.saveDelivery = this.saveDelivery.bind(this)
    this.goBack = this.goBack.bind(this)
    this.confirm = this.confirm.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)

    this.extentAdapter = new ExtentAdapter()
    this._isMounted = false
  }

  componentDidMount () {
    this._isMounted = true
    let addon = this.props.params.addon
    let validParams = ['1', '2', '3', '4', '5', '6', '7', 'bodyextent', 'bodyaddon', 'manualbody']
    if (validParams.indexOf(addon) === -1) {
      // this.props.router.replace('/orders/' + this.props.params.orderID)
      this.props.router.goBack()
    } else {
      this.clearData()
      this.initData()
      this.setManualPrice(this.props)
      this.getRejections()
      window.addEventListener('resize', this.updateDimensions)
      this.updateDimensions()
    }
  }

  componentWillUnmount () {
    this.clearEvents()
    this.clearData()
    window.removeEventListener('resize', this.updateDimensions)
  }

  componentWillReceiveProps (nextProps) {
    if ((this.props.params.orderID !== nextProps.params.orderID) || (this.props.params.addon !== nextProps.params.addon)) {
      this.clearData()
      setTimeout(() => {
        this.initData(nextProps)
        this.getRejections()
      }, 100)
    }
    if (this.props.price.Total !== nextProps.price.Total || this.props.price.Environment !== nextProps.price.Environment) {
      this.setManualPrice(nextProps)
    }

    if (!isEqual(this.props.carSelectedParts, nextProps.carSelectedParts)) {
      if (nextProps.carSelectedParts.length > 0) {
        this.bindCarBodyEvent(nextProps.carSelectedParts)
      }
    }
  }

  updateDimensions () {
    let w = window
    let d = document
    let documentElement = d.documentElement
    let body = d.getElementsByTagName('body')[0]

    let width = w.innerWidth || documentElement.clientWidth || body.clientWidth
    let height = w.innerHeight || documentElement.clientHeight || body.clientHeight

    this.setState({
      dimensions: {
        width: width,
        height: height
      }
    })
  }

  dimensionShow (dimensions) {
    let show = false
    dimensions.map((val, key) => {
      if (!show) {
        let higherThan = val[0]
        let lessThan = val[1]
        let width = this.state.dimensions.width
        if (width > higherThan && width <= lessThan) show = true
      }
    })
    return show
  }

  getRejections () {
    if (this.props.params.orderID !== undefined && this.props.params.orderID > 0) {
      this.props.getRejectedEvaluations(this.props.params.orderID).then((res) => {
        let data = res.data
        this.setState({
          rejections: data
        }, () => {
          // console.log('success', this.state)
        })
      }, () => {
        console.log('failed')
      })
    }
  }
  clearData () {
    this.setState({
      price: {},
      helperPopup: false,
      view: 'euro',
      carswitcher: false,
      car: {
        bodyParts: [],
        parts: [],
        extents: [],
        services: [],
        extra: [],
        mapping: {},
        complaints: [],
        reasons: {},
        otherDamages: [],
        final: {
          bodyParts: [],
          parts: [],
          extra: [],
          services: [],
          addon: [],
          addonStartTimes: []
        }
      },
      eventListener: undefined,
      customer_price: {
        gross_reduced: 'discount',
        discount: 0,
        netprice: 0
      },
      activeTaskId: 0,
      manual: {
        Price: 0,
        Environment: 0,
        OtherDescription: '',
        OtherTitle: ''
      },
      contacts: [],
      draftDeliveryChangePopup: {
        show: false,
        originalDate: '',
        oldDate: '',
        newDate: '',
        changedFromPopup: false
      },
      deliveryTime: ''
    })
  }

  getContacts (data) {
    this.props.getCustomer(data.CustomerId).then((res) => {
      this.setState({
        contacts: res.data.Contacts
      })
    })
  }

  setManualPrice (props) {
    if (Object.keys(props.price).length === 0 || this.props.order.OrderType === 4) return null
    this.setState({
      manual: {
        Price: (formatCurrency(props.price.Total) === '0,00' || formatCurrency(props.price.Total) === '0.0') ? '' : formatCurrency(props.price.Total),
        Environment: (formatCurrency(props.price.Environment) === '0,00' || formatCurrency(props.price.Environment) === '0.0') ? '' : formatCurrency(props.price.Environment)
      }
    })
  }

  initData (props) {
    props = (typeof props === 'undefined') ? this.props : props
    if (props.auth.user.DepartmentType === 1 &&
      this.props.order.IsPaintOrder === true &&
      this.props.order.PaintIsDraft !== true &&
      (this.props.params.addon === '1' || this.props.params.addon === '2')
    ) {
      window.toastr.error(translation('14930'), translation('216'))
      this.props.router.goBack()
    }
    this.clearEvents()
    EventEmitter.addListener('Price_Email_Click', this.openEmail)
    const getPricesAndBind = (res) => {
      // this.getPriceInformations(res.data.OrderType, res.data.BrandOriginal, res.data.CustomerId)
      let brandName = null
      if (res.data.BrandName !== undefined && res.data.BrandName !== null) brandName = res.data.BrandName.Name

      this.getPriceInformations(res.data.OrderType, brandName, res.data.CustomerId)
      // document.addEventListener('carhandler-select-body-ok', this.bindCarBodyEvent)
      document.addEventListener('carhandler-ok', this.bindCarEvent)
      // document.addEventListener('carhandler-ok', this.extentAdapterEventHandler)   // For further refactoring, for clearing up pricecalculation component.
      document.addEventListener('carhandler-booked', this.bindCarEventBooked)
      document.addEventListener('carhandler-noitems', this.bindCarEventNoItems)
    }
    let getPriceBind = true
    return this.props.getOrder(props.params.orderID).then((res) => {
      if (/\/pricecalculation\/\d{6,}/.test(this.props.router.location.pathname)) {
        // Only change if still on '/pricecalculation/xxxxxx'
        this.props.setPageTitle(makeOrderPageTitleObject(res.data))
      }
      if (res.data.Delivery !== null) {
        this.setState({
          deliveryTime: res.data.Delivery,
          draftDeliveryChangePopup: {
            ...this.state.draftDeliveryChangePopup,
            originalDate: res.data.Delivery,
            oldDate: res.data.Delivery,
            newDate: res.data.Delivery
          }
        })
      }
      if (res.data.OrderType === 4) {
        this.setState({
          manual: {
            Price: (formatCurrency(res.data.Price) === '0,00' || formatCurrency(res.data.Price) === '0.0') ? '' : formatCurrency(res.data.Price),
            Environment: (formatCurrency(res.data.Environment) === '0,00' || formatCurrency(res.data.Environment) === '0.0') ? '' : formatCurrency(res.data.Environment),
            OtherDescription: res.data.OtherDescription === null ? '' : res.data.OtherDescription,
            OtherTitle: res.data.OtherTitle === null ? '' : res.data.OtherTitle
          }
        })
      }
      this.getContacts(res.data)
      if (props.params.addon === '4') {
        EventEmitter.addListener('pricecalc_activeitem', this.setactiveitem, this)
        if (res.data.OrderType === 4) {
          getPriceBind = false
          // this.props.router.replace('/orders/' + props.params.orderID)
          this.props.router.goBack()
        }
      }
      if (props.params.addon === '3') {
        if (!res.data.IsEvaluation) {
          // this.props.router.replace('/orders/' + props.params.orderID)
          this.props.router.goBack()
        } else {
          // Check if it's already evaluated?
          if (getPriceBind) {
            getPricesAndBind(res)
          }
        }
      } else {
        if (getPriceBind) {
          getPricesAndBind(res)
        }
      }
      return res
    }, (err) => {
      // this.context.router.replace('/orders/' + props.params.orderID)
      this.props.router.goBack()
      return err
    })
  }

  extentAdapterEventHandler (e) {
    this.extentAdapter.onCarItem(e.type, e.detail)
  }

  clearEvents () {
    // document.removeEventListener('carhandler-select-body-ok', this.bindCarBodyEvent)
    document.removeEventListener('carhandler-ok', this.bindCarEvent)
    // document.removeEventListener('carhandler-ok', this.extentAdapterEventHandler)
    document.removeEventListener('carhandler-booked', this.bindCarEventBooked)
    document.removeEventListener('carhandler-noitems', this.bindCarEventNoItems)
    EventEmitter.removeListener('pricecalc_activeitem', this.setactiveitem)
    EventEmitter.removeListener('Price_Email_Click', this.openEmail)
  }

  setactiveitem (data) {
    console.log('setting activeTaskId: ', data)
    this.setState({
      activeTaskId: data
    })
  }

  mapPartsData (part) {
    let splitted = part.split('_')
    return splitted
  }

  bindCarEventBooked (e) {
    if (e.detail.evaluation) {
      // Toastr
      window.toastr.error(translation('1782'), translation('216'))
    } else {
      // Toastr
      if (this.props.price.HasAwaiting) {
        window.toastr.error(translation('1320'), translation('216'))
      } else {
        window.toastr.error(translation('13407'), translation('216'))
      }
    }
  }

  bindCarEventNoItems (e) {
    // Toastr
    window.toastr.error(translation('13426'), translation('216'))
  }
  bindCarBodyEvent (e) {
    let parts = e // e.detail
    if (e.length === 0) return null
    // let parts = this.props.carSelectedParts
    // this.props.setCarSelectedParts([])
    // const findItem = (items, val) => {
    //   for (var key in items) {
    //     let item = items[key]
    //     if (item.IsSelected && (item.name === val.name || item.OrderTaskId === val.OrderTaskId)) return item
    //   }
    //   return null
    // }
    let finalData = []
    if ((this.props.order.OrderType === 1 && this.props.params.addon === '1') ||
       [ '3', '4' ].includes(this.props.params.addon) ||
       (this.props.price.UseEstimation && this.props.params.addon !== '7')) { // (this.props.params.addon === '3') || (this.props.params.addon === '4') || (this.props.price.UseEstimation)) {
      // Insurnace order
      parts.map((val, index) => {
        let map = this.mapPartsData(val.name)
        if (typeof finalData[map[0]] !== 'undefined') {
          finalData[map[0]].push(val)
        } else {
          finalData[map[0]] = [val]
        }
      })
    } else if (this.props.params.addon === '6' || this.props.params.addon === '5' || this.props.params.addon === '7') {
      // parts = parts[0]
      parts.map((val, index) => {
        let map = this.mapPartsData(val.id)
        if (typeof finalData[map[0]] !== 'undefined') {
          finalData[map[0]].push(val)
        } else {
          finalData[map[0]] = [val]
        }
      })
    } else {
      // parts = parts[0]
      parts.map((val, index) => {
        let map = this.mapPartsData(val.name)
        if (typeof finalData[map[0]] !== 'undefined') {
          finalData[map[0]].push(val)
          // let foundItem = findItem(finalData[map[0]], val)
          // if (foundItem === null) {
          //   if (val.IsSelected === true) {
          //   }
          // } else {
          //   foundItem.IsDeleted = val.IsDeleted
          //   foundItem.Price = val.Price
          //   foundItem.AE = val.AE
          // }
          // if (map[1] === '900000000000000000000' || Number(map[1]) >= '9000000000000000') {
          //   finalData[map[0]].push(val)
          // } else {
          //   finalData[map[0]].push(map[1])
          // }
        } else {
          finalData[map[0]] = [val]
          // if (map[1] === '900000000000000000000' || Number(map[1]) >= '9000000000000000') {
          //   finalData[map[0]] = [val]
          // } else {
          //   finalData[map[0]] = [map[1]]
          // }
        }
      })
    }
    this.setState({
      car: {
        ...this.state.car,
        final: {
          ...this.state.car.final,
          parts: finalData // JSON.parse(JSON.stringify(finalData))
        }
      }
    }, () => {
      // console.log('finalData:', this.state.car.final.parts)
    })
    setTimeout(() => {
      this.getNewPriceCalc('del')
      this.props.setCarSelectedParts([])
    }, 50)
  }
  bindCarEvent (e) {
    let parts = e.detail
    let finalData = []
    if ((this.props.order.OrderType === 1 && this.props.params.addon === '1') || (this.props.params.addon === '3') || (this.props.params.addon === '4') || (this.props.price.UseEstimation)) {
      // Insurnace order
      parts.map((val, index) => {
        let map = this.mapPartsData(val.name)
        if (typeof finalData[map[0]] !== 'undefined') {
          finalData[map[0]].push(val)
        } else {
          finalData[map[0]] = [val]
        }
      })
    } else {
      parts.map((val, index) => {
        let map = this.mapPartsData(val.name)
        if (typeof finalData[map[0]] !== 'undefined') {
          if (map[1] === '900000000000000000000' || Number(map[1]) >= '9000000000000000') {
            finalData[map[0]].push(val)
          } else {
            finalData[map[0]].push(map[1])
          }
        } else {
          if (map[1] === '900000000000000000000' || Number(map[1]) >= '9000000000000000') {
            finalData[map[0]] = [val]
          } else {
            finalData[map[0]] = [map[1]]
          }
        }
      })
    }
    this.setState({
      car: {
        ...this.state.car,
        final: {
          ...this.state.car.final,
          parts: finalData
        }
      }
    })
    setTimeout(() => {
      this.getNewPriceCalc('del')
    }, 50)
  }

  addExtraService (item, type) {
    if (this.props.auth.user.CustomerId !== '-1' && !this.props.order.IsDraft) {
      // if (!this.props.order.IsDraft) {
      this.bindCarEventBooked()
    } else {
      let name = (type === 'extra') ? 'extra' : 'services'
      if (type === 'addon') name = 'addon'
      if (type === 'addonStartTimes') name = 'addonStartTimes'
      let finalData = this.state.car.final[name]
      finalData.push(item)
      this.setState({
        car: {
          ...this.state.car,
          final: {
            ...this.state.car.final,
            [name]: finalData
          }
        }
      })
      setTimeout(() => {
        this.getNewPriceCalc('nodel')
      }, 50)
    }
  }

  findPartArrayFromId (parts, id, taskSide, sideType) {
    for (let i = 0; i < parts.length; i++) {
      let part = parts[i].Part
      if (taskSide !== 0) {
        if (part.PartItemId === id && part.TaskSide === taskSide) {
          return i
        }
      } else {
        if (part.PartItemId === id) {
          return i
        }
      }
    }
    return false
  }

  getTaskSide (key) {
    if (key.indexOf('tag') !== -1) {
      return 0
    }

    if (key.endsWith('-for')) {
      if (key.indexOf('venstre-') !== -1) return 5
      if (key.indexOf('hojre-') !== -1) return 6
    } else if (key.endsWith('-bag')) {
      if (key.indexOf('venstre-') !== -1) return 7
      if (key.indexOf('hojre-') !== -1) return 8
    }

    if (key.indexOf('venstre-') !== -1) {
      return 1
    } else if (key.indexOf('hojre-') !== -1) {
      return 2
    } else if (key.indexOf('for-') !== -1) {
      return 3
    } else if (key.indexOf('bag-') !== -1) {
      return 4
    }
    return 0
  }

  findEstimationTask (tasks, id) {
    for (let i = 0; i < tasks.length; i++) {
      if (tasks[i].EstimationTaskId.toString() === id.toString()) {
        return true
      }
    }
    return false
  }

  getNewPriceCalc (del, servicesData, extra, addonParts, addonTimes, partID, item) {
    let tmpState = Object.assign({}, this.state)

    // Data
    let postData = Object.assign({}, this.props.price)
    const deviationExists = (val, deviationReasons) => {
      let foundItem = false
      if (typeof (deviationReasons) === 'undefined') return false
      // deviationReasons.map((item) => { // Set all reasons to deleted first
      //   if (!item.CustomDeviationReasonId) item.IsDeleted = true
      //   // if (!item.CustomReason) {
      //   //   item.IsDeleted = true
      //   // }
      //   return item
      // })
      deviationReasons.map((item1) => {
        if (!foundItem) {
          if (val.IsCustomDeviation) {
            if (val.IsNew) {
              foundItem = false
            } else if (val.CustomDeviationReasonId === item1.CustomDeviationReasonId) {
              item1.IsDeleted = !val.IsSelected
              foundItem = item1
            } else {
              // console.log('deviationReasonsMap equals not', val, item)
            }
          } else if (!val.IsCustomDeviation && '' + item1.DeviationType.Id === '' + val.EnumValue) {
            item1.IsDeleted = false
            foundItem = item1
          }
        }
        return item
      })
      return foundItem
    }
    // Make parts
    if (typeof partID !== 'undefined') {
      let isUsingOrderEstimationTaskId = false
      // Check if its a OrderEstimationTaskId
      if (typeof partID === 'string') {
        if (partID.indexOf('OrderEstimationTaskId') !== -1) {
          partID = parseInt(partID.split('_')[1])
          isUsingOrderEstimationTaskId = true
        }
      }
      // Set part IsDeleted to true
      postData.Parts.map((val, index) => {
        if (this.props.params.addon === '5' || this.props.params.addon === '6') {
          // DEVIATIONS
          val.DeviationReasons.filter((v, i) => {
            if (item.TaskSide !== 0) {
              if (v.DeviationReasonId === partID && v.TaskSide === item.TaskSide) {
                v.IsDeleted = true
              }
            } else {
              if (v.DeviationReasonId === partID && val.Part.TaskSide === item.TaskSide) {
                v.IsDeleted = true
              }
            }
            return v
          })
          // Custom deviation reasons
          val.CustomDeviationReasons.filter((v, i) => {
            if (item.TaskSide !== 0) {
              if (v.CustomDeviationReasonId === partID && v.TaskSide === item.TaskSide) {
                v.IsDeleted = true
              }
            } else {
              if (v.CustomDeviationReasonId === partID && val.Part.TaskSide === item.TaskSide) {
                v.IsDeleted = true
              }
            }
            return v
          })
        } else if (this.props.params.addon === '7') {
          val.OtherDamages.filter(v => {
            if (item.TaskSide !== 0) {
              if (v.Id === partID && v.TaskSide === item.TaskSide) {
                v.IsDeleted = true
              }
            } else {
              if (v.Id === partID && val.Part.TaskSide === item.TaskSide) {
                v.IsDeleted = true
              }
            }
            return v
          })
        } else if ((this.props.order.OrderType === 1 && this.props.params.addon === '1') || (this.props.params.addon === '3') || (this.props.params.addon === '4') || (this.props.price.UseEstimation)) {
          val.EstimationTasks.filter((v, i) => {
            let checkID = (isUsingOrderEstimationTaskId) ? v.OrderEstimationTaskId : v.EstimationTaskId
            if (item.TaskSide !== 0) {
              if (checkID === partID && v.TaskSide === item.TaskSide) {
                v.IsDeleted = true
              }
            } else {
              if (checkID === partID && val.Part.TaskSide === item.TaskSide) {
                v.IsDeleted = true
              }
            }
            return v
          })
        } else if (this.props.order.OrderType === 5 && this.props.params.addon !== '2' && this.props.params.addon !== 'bodyaddon') {
          // COMPLAINTS
          val.Complaints.filter((v, i) => {
            if (item.TaskSide !== 0) {
              if (v.ComplaintType === partID && v.TaskSide === item.TaskSide) {
                v.IsDeleted = true
              }
            } else {
              if (v.ComplaintType === partID && val.Part.TaskSide === item.TaskSide) {
                v.IsDeleted = true
              }
            }
            return v
          })
        } else {
          val.Tasks.filter((v, i) => {
            // if (item.TaskSide !== 0) {
            //   if (v.OrderTaskId === partID && v.TaskSide === item.TaskSide) {
            //     v.IsDeleted = true
            //   }
            // } else {
            //   if (v.OrderTaskId === partID && val.Part.TaskSide === item.TaskSide) {
            //     v.IsDeleted = true
            //   }
            // }
            return v
          })
        }
      })
      window.carHandler.fillParts(true, postData.Parts)
    } else {
      // Set part IsDeleted to true
      if (del !== 'nodel') {
        postData.Parts.map((val, index) => {
          if (this.props.params.addon === '5' || this.props.params.addon === '6') {
            // val.DeviationReasons.map((v, i) => {
            //   v.IsDeleted = true
            //   return v
            // })
            // val.CustomDeviationReasons.map((v, i) => {
            //   v.IsDeleted = true
            //   return v
            // })
          } else if ((this.props.order.OrderType === 1 && this.props.params.addon === '1') || (this.props.params.addon === '3') || (this.props.params.addon === '4') || (this.props.price.UseEstimation)) {
            /*
            val.EstimationTasks.map((v, i) => {
              v.IsDeleted = true
              return v
            })
            */
          } else if (this.props.order.OrderType === 5 && this.props.params.addon !== '2' && this.props.params.addon !== 'bodyaddon' && this.props.params.addon !== 'manualbody') {
            val.Complaints.map((v, i) => {
              let parts = tmpState.car.final.parts
              for (let key in parts) { // Delete parts that are not selected
                let part = parts[key]
                let partID = this.state.car.mapping[key]
                let taskSide = this.getTaskSide(key)
                let partDataID = this.findPartArrayFromId(postData.Parts, partID, taskSide)
                if (partDataID !== false) {
                  let checkPart = postData.Parts[partDataID].Part
                  if (checkPart.PartItemId === val.Part.PartItemId) {
                    let foundPart = false
                    part.map((p) => {
                      if (!foundPart && p.ComplaintType === v.ComplaintType) foundPart = true
                    })
                    if (!foundPart) v.IsDeleted = true
                  }
                }
              }
              return v
            })
          } else if (this.props.params.addon !== 'bodyextent' && this.props.params.addon !== 'bodyaddon') {
            // val.Tasks.filter((v, i) => {
            //   if (v.PartItemId !== 0) {
            //     v.IsDeleted = true
            //   }
            //   return v
            // })
          }
        })
      }
      if (this.props.params.addon === '5' || this.props.params.addon === '6') {
        // DEVIATION REASONS
        let parts = tmpState.car.final.parts
        for (let key in parts) {
          let partID = this.state.car.mapping[key]
          let partDataID = this.findPartArrayFromId(postData.Parts, partID, this.getTaskSide(key))
          // console.log('added parts', 'key', key, 'partID', partID, 'partDataID', partDataID, 'parts[key]', parts[key])
          if (partDataID === false) {
            let partData = {}
            partData.Part = {
              PartItemId: partID,
              TaskSide: this.getTaskSide(key)
            }
            partData.DeviationReasons = []
            parts[key].map((val, index) => {
              let deviationID = 0
              if (postData.Deviations.length === 0) {
                deviationID = 0
              } else {
                deviationID = postData.Deviations[postData.Deviations.length - 1].DeviationId
              }
              if (typeof (partData.DeviationReasons) === 'undefined') partData.DeviationReasons = []
              if (typeof (partData.CustomDeviationReasons) === 'undefined') partData.CustomDeviationReasons = []
              let reasons = partData.DeviationReasons
              if (val.IsCustomDeviation) reasons = partData.CustomDeviationReasons
              let foundItem = deviationExists(val, reasons)
              if (!foundItem) {
                let reason = {
                  DeviationId: deviationID,
                  TaskSide: this.getTaskSide(key)
                }
                if (!val.IsCustomDeviation) {
                  reason.DeviationType = {
                    Id: val.EnumValue
                  }
                } else {
                  reason.CustomDeviationReasonId = val.CustomDeviationReasonId
                  if (typeof (reason.CustomDeviationReasonId) === 'undefined') reason.CustomDeviationReasonId = 0
                  reason.CustomReason = val.CustomReason
                  reason.IsSelected = val.IsSelected
                  reason.IsDeleted = !val.IsSelected
                }
                reasons.push(reason)
              }
            })
            postData.Parts.push(partData)
          } else {
            postData.Parts[partDataID].DeviationReasons.map((v, i) => {
              v.IsDeleted = true
              return v
            })
            postData.Parts[partDataID].CustomDeviationReasons.map((v, i) => {
              v.IsDeleted = true
              return v
            })
            parts[key].map((val, index) => {
              let reasons = postData.Parts[partDataID].DeviationReasons
              if (val.IsCustomDeviation) reasons = postData.Parts[partDataID].CustomDeviationReasons
              let foundItem = deviationExists(val, reasons)
              if (!foundItem) {
                let reason = {
                  TaskSide: this.getTaskSide(key)
                }
                if (!val.IsCustomDeviation) {
                  reason.DeviationType = {
                    Id: val.EnumValue
                  }
                } else {
                  reason.CustomDeviationReasonId = val.CustomDeviationReasonId
                  if (typeof (reason.CustomDeviationReasonId) === 'undefined') reason.CustomDeviationReasonId = 0
                  reason.CustomReason = val.CustomReason
                  reason.IsSelected = val.IsSelected
                  reason.IsDeleted = !val.IsSelected
                }
                reasons.push(reason)
              } else {
                // console.log('found item, ', 'val', val, 'item', foundItem)
              }
              if (val.IsCustomDeviation) {
                postData.Parts[partDataID].CustomDeviationReasons = reasons
              } else {
                postData.Parts[partDataID].DeviationReasons = reasons
              }
            })
          }
        }
      } else if (this.props.params.addon === '7') {
        // OTHER DAMAGE
        const otherDamageExists = (part, otherDamages) => {
          let foundItem = false

          for (let od of otherDamages) {
            if (od.Type === part.EnumValue) {  // Type match
              if (part.EnumValue === 10) {                // Is custom
                if (od.CustomName === part.name) {        // Is same custom
                  foundItem = true
                }
              } else {
                foundItem = true
              }
            }
          }

          return foundItem
        }

        const parts = tmpState.car.final.parts
        for (const key in parts) {
          const partID = this.state.car.mapping[key]
          const partDataID = this.findPartArrayFromId(postData.Parts, partID, this.getTaskSide(key))

          if (partDataID === false) {
            const partData = {
              Part: {
                PartItemId: partID,
                TaskSide: this.getTaskSide(key)
              },
              OtherDamages: []
            }

            parts[key].forEach(part => {
              let otherDamageID = 0
              if (postData.OtherDamages.length !== 0) {
                otherDamageID = postData.OtherDamages.find(od => !od.Active).Id
              }

              const foundItem = otherDamageExists(part, partData.OtherDamages)
              if (!foundItem) {
                const otherDamage = {
                  OtherDamageId: otherDamageID,
                  TaskSide: this.getTaskSide(key),
                  Type: part.EnumValue,
                  CustomName: part.EnumValue === 10 ? part.CustomName : null,
                  IsDeleted: !part.IsSelected
                }
                partData.OtherDamages = [...partData.OtherDamages, otherDamage]
              }
            })
            postData.Parts = [...postData.Parts, partData]
          } else {
            let otherDamages = postData.Parts[partDataID].OtherDamages
            otherDamages.forEach(od => {
              od.IsDeleted = true
            })

            parts[key].forEach(part => {
              // const foundItem = otherDamageExists(part, otherDamages)

              // if (!foundItem) {
              const otherDamage = {
                TaskSide: this.getTaskSide(key),
                Type: part.EnumValue,
                CustomName: part.EnumValue === 10 ? part.CustomName : null,
                IsDeleted: !part.IsSelected
              }
              otherDamages = [...otherDamages, otherDamage]
              // }
            })
            postData.Parts[partDataID].OtherDamages = otherDamages
          }
        }
      } else if ((this.props.order.OrderType === 1 && this.props.params.addon === '1') || (this.props.params.addon === '3') || (this.props.params.addon === '4') || (this.props.price.UseEstimation)) {
        // Order is INSURANCE, add special
        let parts = tmpState.car.final.parts
        for (let key in parts) {
          let partID = this.state.car.mapping[key]
          let partDataID = this.findPartArrayFromId(postData.Parts, partID, this.getTaskSide(key))
          if (partDataID === false) {
            let partData = {}
            partData.Part = {
              PartItemId: partID,
              TaskSide: this.getTaskSide(key)
            }
            partData.Tasks = []
            partData.EstimationTasks = []

            parts[key].map((val, index) => {
              let splitted = val.name.split('_')
              let id = splitted[1]
              let extras = []
              if (typeof val.value !== 'undefined') {
                var isThere = this.findEstimationTask(partData.EstimationTasks, id)
                if (!isThere) {
                  val.value.extra.map((v, k) => {
                    extras.push({
                      EstimationExtraId: v.id.split('_')[2],
                      AE: v.ae,
                      Material: v.mat,
                      Name: v.name
                    })
                  })
                  partData.EstimationTasks.push({
                    EstimationTaskId: id,
                    TaskName: val.taskname,
                    Extent: {
                      PriceModelExtentId: typeof (val.value.extent) !== 'undefined' ? val.value.extent.split('_')[2] : 0,
                      Type: val.value.type
                    },
                    Extras: extras,
                    TaskSide: this.getTaskSide(key),
                    PaintLineId: this.state.activeTaskId
                  })
                } else {

                }
              }
            })

            postData.Parts.push(partData)
          } else {
            parts[key].map((val, index) => {
              let splitted = val.name.split('_')
              let id = splitted[1]
              let extras = []
              if (typeof val.value !== 'undefined') {
                var isThere = this.findEstimationTask(postData.Parts[partDataID].EstimationTasks, id)
                if (!isThere || id === '0') {
                  val.value.extra.map((v, k) => {
                    extras.push({
                      EstimationExtraId: v.id.split('_')[2],
                      AE: v.ae,
                      Material: v.mat,
                      Name: v.name
                    })
                  })
                  postData.Parts[partDataID].EstimationTasks.push({
                    TaskName: val.taskname,
                    PartName: key,
                    EstimationTaskId: id,
                    Extent: {
                      PriceModelExtentId: typeof (val.value.extent) !== 'undefined' ? val.value.extent.split('_')[2] : 0,
                      Type: val.value.type
                    },
                    Extras: extras,
                    TaskSide: this.getTaskSide(key),
                    PaintLine: this.state.activeTaskId,
                    OrderEstimationTaskId: 0
                  })
                } else {
                  // Find estimationTaskIdx
                  let estimationTask = null
                  let estimationTaskIdx = null
                  for (let i = 0; i < postData.Parts[partDataID].EstimationTasks.length; i++) {
                    if (postData.Parts[partDataID].EstimationTasks[i].EstimationTaskId === parseInt(id)) {
                      estimationTask = postData.Parts[partDataID].EstimationTasks[i]
                      estimationTaskIdx = i
                      break
                    }
                  }
                  // Extent
                  if (estimationTask !== null) {
                    if (val.value.extent !== undefined && val.value.extent.split('_')[2] !== undefined) {
                      estimationTask.Extent = {
                        PriceModelExtentId: val.value.extent.split('_')[2]
                      }
                      postData.Parts[partDataID].EstimationTasks[estimationTaskIdx.toString()] = estimationTask
                    }
                  }
                  // EstimationTask is present, update its extras.
                  val.value.extra.map((v, k) => {
                    if (estimationTask !== null) {
                      let extraFound = false
                      for (let i = 0; i < estimationTask.Extras.length; i++) {
                        if (estimationTask.Extras[i].EstimationExtraId === parseInt(v.id.split('_')[2])) extraFound = true
                      }
                      if (!extraFound) {
                        estimationTask.Extras.push({
                          EstimationExtraId: parseInt(v.id.split('_')[2]),
                          AE: v.ae,
                          Material: v.mat
                        })
                      }
                    }
                    postData.Parts[partDataID].EstimationTasks[estimationTaskIdx.toString()] = estimationTask
                  })
                }
              }
            })
          }
        }
      } else if (this.props.order.OrderType === 5 && this.props.params.addon !== '2' && this.props.params.addon !== 'bodyaddon') {
        // COMPLAINTS
        let parts = tmpState.car.final.parts
        for (let key in parts) {
          let partID = this.state.car.mapping[key]
          let taskSide = this.getTaskSide(key)
          let partDataID = this.findPartArrayFromId(postData.Parts, partID, taskSide)
          // console.log('partDataID', partDataID, 'postData.Parts', postData.Parts, 'partID', partID, 'taskSide', taskSide)
          if (partDataID === false) {
            let partData = {}
            partData.Part = {
              PartItemId: partID,
              TaskSide: taskSide
            }
            partData.Complaints = []
            parts[key].map((val, index) => {
              partData.Complaints.push({
                ComplaintType: val.ComplaintType !== undefined ? val.ComplaintType : val.EnumValue,
                TaskSide: taskSide
              })
            })
            postData.Parts.push(partData)
          } else {
            parts[key].map((val, index) => {
              postData.Parts[partDataID].Complaints.push({
                ComplaintType: val.ComplaintType !== undefined ? val.ComplaintType : val.EnumValue,
                TaskSide: taskSide
              })
            })
          }
        }
      } else {
        // Check if we should add some tasks
        let parts = tmpState.car.final.parts
        for (let key in parts) {
          let partID = this.state.car.mapping[key]
          let partDataID = this.findPartArrayFromId(postData.Parts, partID, this.getTaskSide(key))
          if (partDataID === false) {
            let partData = {}
            partData.Part = {
              PartItemId: partID,
              TaskSide: this.getTaskSide(key)
            }
            partData.Tasks = []
            parts[key].map((val, index) => {
              if (val.IsNew === true) val.OrderTaskId = 0
              partData.Tasks.push(val)
            })
            postData.Parts.push(partData)
          } else {
            parts[key].map((val, index) => {
              if (val.IsNew === true) val.OrderTaskId = 0
              postData.Parts[partDataID].Tasks.push(val)
            })
          }
        }
      }
    }

    // Make addon parts
    postData.OrderAddonParts = (typeof addonParts !== 'undefined') ? addonParts : postData.OrderAddonParts
    // postData.OrderAddonParts = postData.OrderAddonParts
    let addons = tmpState.car.final.addon
    addons.map((val, index) => {
      postData.OrderAddonParts.push({
        AddonPartId: val.AddonPartId
      })
    })

    // Make addon start times
    postData.OrderAddonStartTimes = (typeof addonTimes !== 'undefined') ? addonTimes : postData.OrderAddonStartTimes
    // postData.OrderAddonStartTimes = postData.OrderAddonStartTimes
    let addonStartTimes = tmpState.car.final.addonStartTimes
    addonStartTimes.map((val, index) => {
      postData.OrderAddonStartTimes.push({
        AddonStartTimeId: val.AddonStartTimeId
      })
    })

    // Make extra
    postData.Extras = (typeof extra !== 'undefined') ? extra : postData.Extras
    let extras = tmpState.car.final.extra
    extras.map((val, index) => {
      postData.Extras.push({
        ServiceTaskId: val.ServiceId
      })
    })

    // Make services
    postData.Services = (typeof servicesData !== 'undefined') ? servicesData : postData.Services
    let services = tmpState.car.final.services
    services.map((val, index) => {
      postData.Services.push({
        ServiceTaskId: val.ServiceId
      })
    })

    // Set new state
    this.setState({
      car: {
        ...this.state.car,
        final: {
          ...this.state.car.final,
          parts: [],
          services: [],
          extra: [],
          addon: [],
          addonStartTimes: []
        }
      }
    })

    // Evaluation
    if (this.props.params.addon === '3') {
      postData.IsEvaluation = true
    }
    // AfterEvaluation
    if (this.props.params.addon === '4') {
      postData.IsAfterEvaluation = true
    }

    // Update prices
    this.setState({ isUpdating: true }, () => {
      this.props.updatePrices(postData).then((res) => {
        this.setState({
          draftDeliveryChangePopup: {
            ...this.state.draftDeliveryChangePopup,
            newDate: res.data.DeliveryAfter
          }
        })
        this.setState({
          isUpdating: false,
          customer_price: {
            ...this.state.customer_price,
            discount: res.data.DiscountCustomer,
            netprice: res.data.NetCustomer
          },
          activeTaskId: 0
        })
        EventEmitter.emit('pricecalc_activeitem_done', 0)
      }, () => {
        this.setState({
          isUpdating: false
        })
      })
    })
  }

  getPriceInformations (type, brand, customerId) {
    if (this.state.gettingPriceInformation === true) return // Added state to check and cancel if request already running
    this.setState({gettingPriceInformation: true}, () => {
      let deviation = null
      let otherDamage = false
      let IsEstimation = false
      let isAddonSale = false
      if (this.props.params.addon === '5' || this.props.params.addon === '6') {
        deviation = (this.props.params.addon === '5') ? 0 : 1
      }
      if (this.props.params.addon === '3' || this.props.params.addon === '4') {
        IsEstimation = true
      }
      if (this.props.params.addon === '2' || this.props.params.addon === 'bodyaddon') {
        isAddonSale = true
      }
      if (this.props.params.addon === '7') {
        otherDamage = true
      }
      let orderId = -1
      if (this.props.order !== undefined && this.props.order !== null && this.props.order.Id !== undefined && this.props.order.Id !== null) {
        orderId = this.props.order.Id
      }
      let request = {
        type: type,
        brand: brand,
        customerId: customerId,
        deviation: deviation,
        IsOtherDamage: otherDamage,
        IsEstimation: IsEstimation,
        isAddon: isAddonSale,
        orderId: orderId,
        isBodyShop: ['bodyextent', 'bodyaddon', 'manualbody', '7'].indexOf(this.props.params.addon) !== -1 // this.props.params.addon === 'bodyextent' || this.props.params.addon === 'bodyaddon'
      }
      this.props.getPriceInformation(request).then((res) => {
        // Create a mapping here aswell
        let mapping = []
        res.data.Parts.map((val, index) => {
          mapping[val.Mapping] = val.PartId
        })
        // Set car state
        this.setState({
          price: res.data,
          car: {
            ...this.state.car,
            extents: res.data.Extents,
            parts: res.data.Parts,
            services: res.data.Services,
            extra: res.data.Extra,
            AddonParts: res.data.AddonParts,
            AddonStartTimes: res.data.AddonStartTimes,
            complaints: res.data.ComplaintTypes,
            mapping: mapping,
            reasons: res.data.DeviationReasons,
            otherDamages: res.data.OtherDamages,
            final: {
              parts: [],
              extra: [],
              services: [],
              addon: [],
              addonStartTimes: []
            }
          }
        }, () => {
          this.props.setCarParts(this.state.car.parts)
        })
      }, () => {
        // Toastr
        if (isAddonSale) {
          window.toastr.error(translation('2262'), translation('216'))
        } else {
          window.toastr.error(translation('2087'), translation('216'))
        }
        // this.props.router.replace('/orders/' + this.props.params.orderID)
        this.props.router.goBack()
      })
      this.setState({gettingPriceInformation: false})
    })
  }

  isPriceCalc () {
    // console.log('isPriceCalc -> this.state.price', this.state.price)
    if (!this.state.price || this.state.price.UsingEstimationFallback === undefined || this.state.price.UsingEstimationFallback) return false

    if (/* this.props.params.addon === '2' ||  */this.props.params.addon === 'bodyaddon') {
      return true
    }

    if (['3', '4', '5', '6', '7'].indexOf(this.props.params.addon) !== -1) { // this.props.params.addon === '3' || this.props.params.addon === '4' || this.props.params.addon === '5' || this.props.params.addon === '6') {
      return false
    }
    return !(this.props.order.OrderType === 1 || this.props.order.OrderType === 4 || this.props.order.OrderType === 5 /* || this.props.order.OrderType === 2 */)
  }

  renderAddons () {
    if (this.props.params.addon === 'manualbody') return null
    if (this.props.price.HasAwaiting) return null
    if (this.props.price.CarSize === 0) return null
    if (this.state.price.UsingEstimationFallback) return null
    if (this.state.car.AddonParts === undefined) return null
    if ((this.props.order.OrderType === 1 && this.props.params.addon === '1') || ['3', '4', '5', '6', '7'].indexOf(this.props.params.addon) !== -1) return null// this.props.params.addon === '3' || this.props.params.addon === '4' || this.props.params.addon === '5' || this.props.params.addon === '6') return null
    let { AddonParts } = this.state.car
    let { AddonStartTimes } = this.state.car

    return (
      <Panel title={translation('1792')}>
        {AddonParts.map((val, index) => {
          let labelText = (
            <span>
              <i className='fa fa-plus' /> {val.Name}
            </span>
          )
          return (
            <Button style='link' size='m' key={index} onClick={this.addExtraService.bind(this, val, 'addon')} labelText={labelText} />
          )
        })}
        {AddonStartTimes.map((val, index) => {
          let labelText = (
            <span>
              <i className='fa fa-plus' /> {val.Name}
            </span>
          )
          return (
            <Button style='link' size='m' key={index} onClick={this.addExtraService.bind(this, val, 'addonStartTimes')} labelText={labelText} />
          )
        })}
      </Panel>
    )
  }

  renderExtraServices () {
    if (this.props.params.addon === 'manualbody') return null
    if (this.props.price.HasAwaiting) return null
    if (this.props.price.CarSize === 0) return null
    if ((this.props.order.OrderType === 1 && this.props.params.addon === '1') || ['3', '4', '5', '6', '7'].indexOf(this.props.params.addon) !== -1) return null // this.props.params.addon === '3' || this.props.params.addon === '4' || this.props.params.addon === '5' || this.props.params.addon === '6') return null
    let items = this.state.car.extra
    let translateKey = this.props.params.addon === 'bodyextent' || this.props.params.addon === 'bodyaddon' ? '14820' : '2224'
    // No services
    if (items.length === 0) {
      return (
        <Panel title={translation(translateKey)}>
          {translation('13380')}
        </Panel>
      )
    }
    // Render services
    return (
      <Panel title={translation(translateKey)}>
        {items.map((val, index) => {
          let labelText = (
            <span>
              <i className='fa fa-plus' /> {val.Name}
            </span>
          )
          return (
            <Button style='link' size='m' key={index} onClick={this.addExtraService.bind(this, val, 'extra')} labelText={labelText} />
          )
        })}
      </Panel>
    )
  }

  renderServices () {
    if (this.props.price.CarSize === 0) return null
    if ((this.props.order.OrderType === 1 && this.props.params.addon === '1') || ['3', '4', '5', '6', '7'].indexOf(this.props.params.addon) !== -1) return null // this.props.params.addon === '3' || this.props.params.addon === '4' || this.props.params.addon === '5' || this.props.params.addon === '6') return null
    if (this.props.auth.user.CustomerId === '-1') return null
    let items = this.state.car.services
    let translateKey = '13375'
    // No extra services
    if (items.length === 0) {
      return (
        <Panel title={translation(translateKey)}>
          {translation('13381')}
        </Panel>
      )
    }
    // Render extra services
    return (
      <Panel title={translation(translateKey)}>
        {items.map((val, index) => {
          let labelText = (
            <span>
              <i className='fa fa-plus' /> {val.Name}
            </span>
          )
          return (
            <Button style='link' size='m' key={index} onClick={this.addExtraService.bind(this, val, 'services')} labelText={labelText} />
          )
        })}
      </Panel>
    )
  }

  renderActions () {
    // Todo, ACTIVE TAB
    const changeTab = (view, e) => {
      e.preventDefault()
      this.setState({
        view: (view === 'euro') ? 'euro' : 'car car' + view
      })
    }
    const activeTab = (id) => {
      if (this.state.view === 'euro' && id === 'euro') {
        return 'active'
      } else if (this.state.view === 'car car' + id) {
        return 'active'
      }
      return ''
    }

    return (
      <div>
        <div className='car__actions clearfix'>
          <a className={'change_car_view ' + activeTab('1')} data-type='front' onClick={changeTab.bind(this, '1')}>
            {activeTab('1') !== 'active' && <span style={{ backgroundImage: 'url(/images/icons/car/Car-front-Black.png)' }} />}
            {activeTab('1') === 'active' && <span style={{ backgroundImage: 'url(/images/icons/car/Car-front-White.png)' }} />}
          </a>
          <a className={'change_car_view ' + activeTab('2')} data-type='right' onClick={changeTab.bind(this, '2')}>
            {activeTab('2') !== 'active' && <span style={{ backgroundImage: 'url(/images/icons/car/Car-Right-Black.png)' }} />}
            {activeTab('2') === 'active' && <span style={{ backgroundImage: 'url(/images/icons/car/Car-Right-White.png)' }} />}
          </a>
          <a className={'change_car_view ' + activeTab('3')} data-type='back' onClick={changeTab.bind(this, '3')}>
            {activeTab('3') !== 'active' && <span style={{ backgroundImage: 'url(/images/icons/car/Car-Back-Black.png)' }} />}
            {activeTab('3') === 'active' && <span style={{ backgroundImage: 'url(/images/icons/car/Car-Back-White.png)' }} />}
          </a>
          <a className={'change_car_view ' + activeTab('4')} data-type='left' onClick={changeTab.bind(this, '4')}>
            {activeTab('4') !== 'active' && <span style={{ backgroundImage: 'url(/images/icons/car/Car-Left-Black.png)' }} />}
            {activeTab('4') === 'active' && <span style={{ backgroundImage: 'url(/images/icons/car/Car-Left-White.png)' }} />}
          </a>
          <a className={'change_car_view ' + activeTab('5')} data-type='roof' onClick={changeTab.bind(this, '5')}>
            {activeTab('5') !== 'active' && <span style={{ backgroundImage: 'url(/images/icons/car/Car-Roof-Black.png)' }} />}
            {activeTab('5') === 'active' && <span style={{ backgroundImage: 'url(/images/icons/car/Car-Roof-White.png)' }} />}
          </a>
          <a className={'' + activeTab('euro')} onClick={changeTab.bind(this, 'euro')}>
            {activeTab('euro') !== 'active' && <span style={{ backgroundImage: 'url(/images/icons/payment16.png)' }} />}
            {activeTab('euro') === 'active' && <span style={{ backgroundImage: 'url(/images/icons/payment16_white.png)' }} />}
          </a>
        </div>
      </div>
    )
  }

  renderCarSize () {
    if (['3', '4', '5', '6', '7'].indexOf(this.props.params.addon) !== -1 || this.state.price.UsingEstimationFallback) return null // this.props.params.addon === '3' || this.props.params.addon === '4' || this.props.params.addon === '5' || this.props.params.addon === '6' || this.state.price.UsingEstimationFallback) return null
    if (this.props.params.addon === '1') {
      if (this.props.order.OrderType === 1 || this.props.order.OrderType === 5) {
        return null
      }
    }
    let carSizeNum = this.props.price.CarSize
    if (carSizeNum === 0) {
      // carSizeNum = 2
    }
    let carsize = this.props.carSizes[carSizeNum]
    const changeCarSize = (size) => {
      let postData = Object.assign({}, this.props.price)
      postData.CarSize = size
      // Evaluation
      if (this.props.params.addon === '3') {
        postData.IsEvaluation = true
      }
      // AfterEvaluation
      if (this.props.params.addon === '4') {
        postData.IsAfterEvaluation = true
      }
      this.props.updatePrices(postData)
      this.setState({
        car: {
          ...this.state.car,
          size: size
        },
        carswitcher: false
      })
    }
    const triggerSwitcher = () => {
      this.setState({
        carswitcher: true
      })
    }
    const openHelperModal = () => {
      this.props.triggerPopup(!this.state.helperPopup)
      this.setState({
        helperPopup: !this.state.helperPopup
      })
    }
    const carIconLabel = (size, noLabel = false) => {
      let icon = ''
      let label = ''
      switch (size) {
        case 'S':
          icon = CarIcons.Small
          label = translation('1264')
          break
        case 'M':
          icon = CarIcons.Medium
          label = translation('13342')
          break
        case 'L':
          icon = CarIcons.Large
          label = translation('1266')
          break
      }
      return noLabel ? <Icon icon={icon} /> : [
        <Icon icon={icon} />,
        <div>{label}</div>
      ]
    }
    let sizeLetter = 'L'
    if (carsize === 'medium') sizeLetter = 'M'
    if (carsize === 'small') sizeLetter = 'S'
    let display = (
      <div className='carsize__box'>
        <Grid cols={['min-content']}>
          <Button style='link' onClick={triggerSwitcher.bind(this)} labelText={carIconLabel(sizeLetter, true)} />
        </Grid>
      </div>
    )

    if (this.props.params.addon === 'bodyextent' || this.props.params.addon === 'bodyaddon' || this.props.params.addon === 'manualbody') display = null
    if (this.props.auth.user.CustomerId === '-1' || this.props.order.IsDraft) {
      if (this.state.carswitcher || carSizeNum === 0) {
        display = (
          <div className='carsize__box'>
            <CarsizeModal
              show={this.state.helperPopup}
              onClose={openHelperModal} />
            <Grid cols={['min-content', 'min-content', 'min-content', 'min-content']}>
              <Button style='link' onClick={openHelperModal.bind(this)} className='helper__icon'>
                <Icon icon={ElementIcons.Info_Circle} />
              </Button>
              <Button style='link' onClick={changeCarSize.bind(this, 1)} labelText={carIconLabel('S')} />
              <Button style='link' onClick={changeCarSize.bind(this, 2)} labelText={carIconLabel('M')} />
              <Button style='link' onClick={changeCarSize.bind(this, 3)} labelText={carIconLabel('L')} />
            </Grid>
          </div>
        )
      }
    }

    return display
  }

  renderEvaluation () {
    if (this.props.params.addon !== '3') return null    // && !this.state.price.UsingEstimationFallback
    if (this.state.price.UsingEstimationFallback === undefined) return null // to handle double Estimation OrderPrices
    // Filter away normal files
    return (
      <div className='evaluationBox'>
        <HeaderElement text={translation('13363')} />
        <Evaluation orderId={this.props.order.Id} isEdit />
      </div>
    )
  }

  renderInsuranceManual () {
    if (((this.props.params.addon === '1' && this.props.order.OrderType === 1) || this.state.price.UsingEstimationFallback) && this.props.params.addon !== '5' && this.props.params.addon !== '6' && this.props.params.addon !== '7') {
      if (this.props.order.OrderType === 4) return null
      // Environment
      const onInputChange = (e) => {
        this.setState({
          manual: {
            ...this.state.manual,
            [e.target.name]: e.target.value
          }
        })
      }
      const onBlur = (e) => {
        // Data
        let postData = Object.assign({}, this.props.price)
        if (e.target.name === 'Price') {
          postData.Total = parseFloat(reverseFormatCurrency(e.target.value))
        } else {
          postData.Environment = parseFloat(reverseFormatCurrency(e.target.value))
        }
        postData.HoldTotal = true
        this.setState({
          isUpdating: true,
          manualPriceChanged: true
        })
        this.props.updatePrices(postData).then((res) => {
          this.setState({
            isUpdating: false,
            manual: {
              Price: (formatCurrency(res.data.Total) === '0,00' || formatCurrency(res.data.Total) === '0.0') ? '' : formatCurrency(res.data.Total),
              Environment: (formatCurrency(res.data.Environment) === '0,00' || formatCurrency(res.data.Environment) === '0.0') ? '' : formatCurrency(res.data.Environment)
            }
          })
        })
      }

      let beforeDiscountLabel = ''
      if (this.props.order.HasDiscount || this.props.order.AddonHasDiscount) {
        beforeDiscountLabel = ` ${translation('15012')}`
      }

      return (
        <div>
          <h3>{translation('1913')}</h3>
          <Text labelText={translation('641') + beforeDiscountLabel} name='Price' onBlur={onBlur} onChange={onInputChange} value={this.state.manual.Price} placeholder='0,00' />
          <Text labelText={translation('13339') + beforeDiscountLabel} name='Environment' onBlur={onBlur} onChange={onInputChange} value={this.state.manual.Environment} placeholder='0,00' />
        </div>
      )
    } else {
      return null
    }
  }

  openEmail () {
    this.setState({
      showEmail: !this.state.showEmail
    })
  }

  renderSendEmail () {
    if (!this.isPriceCalc()) return null
    if (Object.keys(this.props.price).length === 0) return null
    if (this.props.price.CarSize === 0) return null
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))

    const submitForm = (e) => {
      // e.preventDefault()
      let data = { ...this.props.price }
      data.SendMail = {
        UserId: (isCustomer) ? 0 : parseInt(this.state.SelectedContact),
        Email: (isCustomer) ? this.state.SelectedContactMail : null
      }
      if (!isCustomer && data.SendMail.UserId === 0 && this.state.contacts.length !== 0) {
        data.SendMail.UserId = this.state.contacts[0].UserId
      }
      this.props.updatePrices(data).then((res) => {
        // window.toastr.success(translation('13004'), translation('13424')) // Offer was sent
      }, () => {
        window.toastr.error(translation('2250'), translation('216'))
      })
    }
    const onChange = (e) => {
      if (e.target.name === 'sendtoemail') {
        this.setState({
          SelectedContact: e.target.value
        })
      } else {
        this.setState({
          [e.target.name]: e.target.value
        })
      }
    }
    return (
      <div className='sendEmailBox'>
        {isCustomer ? (
          <Text name='SelectedContactMail' value={this.state.SelectedContactMail} onChange={onChange} labelText={translation('1052')} />
        ) : (<div>
          <HeaderElement text={translation('346')} />
          <DropDown name='sendtoemail' value={this.state.SelectedContact} onChange={onChange}>
            {this.state.contacts.map((contact, key) => {
              if (contact.Active !== true || typeof contact.Mail !== 'string' || contact.Mail.indexOf('@') === -1) return null
              return (
                <option value={contact.UserId} key={key}>{contact.Name + ' (' + contact.Mail + ')'}</option>
              )
            })}
          </DropDown>
        </div>
          )}
        <Button labelText={translation('1301')} onClick={submitForm} />
      </div>
    )
  }

  postCancel () {
    // if (true /* this.props.price.ApprovalShop === 1 || this.props.price.ApprovalCustomer === 1 */) {
    let postData = this.props.price
    postData.CancelEditing = true
    return this.props.updatePrices(postData)
    // }
  }

  render () {
    const EXTENT_TYPE = {
      BASE: '1',
      BODY_EXTENT: 'bodyextent',
      BODY_MANUAL: 'manualbody',
      ADDON: '2',
      BODY_ADDON: 'bodyaddon',
      EVALUATION: '3',
      AFTER_EVALUATION: '4',
      INT_DEVIATION: '5',
      EXT_DEVIATION: '6',
      OTHER_DAMAGE: '7'
    }

    if (typeof this.props.order.Id === 'undefined') return null
    let isCreatingDeviation = (this.props.params.addon === '5' || this.props.params.addon === '6')
    if (!hasSubscriptionPermission(this.props.auth, 10, 20) && isCreatingDeviation) return null
    if (!hasSubscriptionPermission(this.props.auth, 10, 2) && !(hasSubscriptionPermission(this.props.auth, 10, 20) && isCreatingDeviation)) return null

    // Control variables
    // let addon = false
    let evaluation = false
    let afterEvaluation = false
    let deviation = false
    // let otherDamage = false

    let extentType = 'base'

    // if (this.props.params.addon === EXTENT_TYPE.BASE || this.props.params.addon === EXTENT_TYPE.BODY_EXTENT || this.props.params.addon === EXTENT_TYPE.BODY_MANUAL) {
    //   addon = false
    // }

    switch (this.props.params.addon) {
      case EXTENT_TYPE.BASE:
        extentType = 'base'
        if (this.state.price.UsingEstimationFallback) {
          evaluation = true   // Estimation fallback for addon sales
          // extentType = 'eval'
        }
        break
      case EXTENT_TYPE.BODY_EXTENT:
        extentType = 'base'
        break
      case EXTENT_TYPE.BODY_MANUAL:
        extentType = 'base'
        break
      case EXTENT_TYPE.ADDON:
        // addon = true
        extentType = 'addon'
        if (this.state.price.UsingEstimationFallback) {
          evaluation = true   // Estimation fallback for addon sale
          extentType = 'eval'
        }
        break
      case EXTENT_TYPE.BODY_ADDON:
        // addon = true
        extentType = 'addon'
        break
      case EXTENT_TYPE.EVALUATION:
        evaluation = true
        extentType = 'eval'
        break
      case EXTENT_TYPE.AFTER_EVALUATION:
        afterEvaluation = true
        extentType = 'aftereval'
        break
      case EXTENT_TYPE.INT_DEVIATION:
        deviation = 0
        // evaluation = false
        extentType = 'intdeviation'
        break
      case EXTENT_TYPE.EXT_DEVIATION:
        deviation = 1
        // evaluation = false
        extentType = 'extdeviation'
        break
      case EXTENT_TYPE.OTHER_DAMAGE:
        // otherDamage = true
        extentType = 'otherdamage'
        break
    }

    // // Evaluation
    // let evaluation = false
    // if (this.props.params.addon === EXTENT_TYPE.EVALUATION || this.state.price.UsingEstimationFallback) {
    //   evaluation = true
    //   addon = false
    // }
    // // After evaluation
    // let afterEvaluation = false
    // if (this.props.params.addon === EXTENT_TYPE.AFTER_EVALUATION) {
    //   afterEvaluation = true
    //   addon = false
    // }

    // // Estimation fallback for addon sale
    // if ((this.props.params.addon === EXTENT_TYPE.ADDON || this.props.params.addon === EXTENT_TYPE.BODY_ADDON) && this.state.price.UsingEstimationFallback) {
    //   evaluation = true
    //   addon = true
    // }

    // // Deviation
    // let deviation = false
    // if (this.props.params.addon === EXTENT_TYPE.INT_DEVIATION || this.props.params.addon === EXTENT_TYPE.EXT_DEVIATION) {
    //   deviation = (this.props.params.addon === EXTENT_TYPE.INT_DEVIATION) ? 0 : 1
    //   addon = false
    //   evaluation = false
    // }

    // let otherDamage = false
    // if (this.props.params.addon === EXTENT_TYPE.OTHER_DAMAGE) {
    //   otherDamage = true
    //   addon = false
    // }

    // let extentType = 'base'
    // if (evaluation) {
    //   extentType = 'eval'
    // }
    // if (addon) {
    //   extentType = 'addon'
    // }
    // if (afterEvaluation) {
    //   extentType = 'aftereval'
    // }
    // if (deviation === 0) {
    //   extentType = 'intdeviation'
    // }
    // if (deviation === 1) {
    //   extentType = 'extdeviation'
    // }
    // if (otherDamage) {
    //   extentType = 'otherdamage'
    // }

    let isBodyShop = [ EXTENT_TYPE.BODY_EXTENT, EXTENT_TYPE.BODY_ADDON, EXTENT_TYPE.BODY_MANUAL, EXTENT_TYPE.OTHER_DAMAGE ].includes(this.props.params.addon)
    let headerButtonsGoBack
    if (window.LocalstorageStack.top() !== false && typeof headerButtonsGoBack !== 'undefined' && (window.LocalstorageStack.top().pathname === '/orders/' || window.LocalstorageStack.top().pathname === '/orders')) {
      headerButtonsGoBack = (router, t) => {
        const goBack = () => {
          this.clearData()
          this.props.router.replace({
            pathname: '/orders',
            query: {
              orderid: this.props.order.Id
            }
          })
        }
        return <CloseButton onClick={goBack} ariaText={t('2060')} />
      }
    }

    if (typeof headerButtonsGoBack === 'undefined') {
      headerButtonsGoBack = (router, t) => {
        const goBack = (type) => {
          if (type === 'back') {
            this.checkPopupGoBack()
          } else if (shouldHaveArrow() && type === 'close') {
            this.checkPopupGoBack(true)
          } else {
            // Check if orderprice has edits.
            if (this.props.price.ApprovalShop === 1 || this.props.price.ApprovalCustomer === 1) {
              let postData = this.props.price
              postData.CancelEditing = true
              this.checkPopupGoBack(true)
            } else {
              this.checkPopupGoBack()
            }
          }
        }
        const renderArrowBack = () => {
          let topOfStack = window.LocalstorageStack.top()
          if (topOfStack && !shouldHaveArrow()) {
            return null
          }
          return <BackButton ariaText={translation('394')} onClick={goBack.bind(this, 'back')} />
        }
        return (
          <div key='back_close'>
            {renderArrowBack()}
            <CloseButton onClick={goBack.bind(this, 'close')} ariaText={t('2060')} />
          </div>
        )
      }
    }
    // Render
    let extent = this.refs['extent']
    if (extent !== undefined) {
      this.extentAdapter.setExtent(extent)
    }
    let confirmExitText = ''
    if (this.props.price.IsAfterEvaluation) {
      confirmExitText = translation(15209)
    } else if (this.props.price.IsAddonPrice) {
      confirmExitText = translation(16833)
    } else {
      confirmExitText = translation(13252)
    }

    let viewMode
    let renderInside
    const isMobile = this.dimensionShow([[0, 751]])
    if (isMobile) {
      viewMode = 'mobile'
      renderInside = () => {
        return this.renderActions()
      }
    }

    let doRenderCarArea = ((!isBodyShop && (hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20))) || (isBodyShop && hasSubscriptionPermission(this.props.auth, 20)))
    let doRenderExtrasArea = doRenderCarArea && this.isPriceCalc()
    let doRenderExtentArea = true

    // console.log('PriceCalculation -> extentType', extentType, 'deRenderCarArea', doRenderCarArea, 'this.props', this.props, 'car', this.state.car)

    const renderCarArea = () => {
      return (
        <div id='carArea' className={'view_' + this.state.view}>
          <Panel clearfix>
            {(this.props.order.OrderType !== 4) && <div className='car__outer_wrapper'>
              {this.renderActions()}
              {this.renderCarSize()}
              <div className='car__wrapper'>
                <Car data={this.state.car} addon={this.props.params.addon} afterEvaluation={afterEvaluation} evaluation={evaluation} deviation={deviation} />
              </div>
            </div>}
          </Panel>
        </div>
      )
    }

    const renderExtrasArea = () => {
      return (
        <div id='extrasArea' className={'view_' + this.state.view}>
          <div className='extra_wrapper'>
            {this.renderAddons()}
            {this.renderExtraServices()}
            {!isBodyShop && this.renderServices()}
          </div>
        </div>
      )
    }

    const renderExtentArea = () => {
      return (
        <div id='extentArea' className={'view_' + this.state.view}>
          <Panel clearfix>
            {this.renderEvaluation()}
            { /* this.renderInsuranceManual() */ }
            {(this.props.order.OrderType !== 4) && <div className='car__outer_wrapper'>
              {!isMobile && this.renderActions()}
              <Extent
                ref='extent'
                order={this.props.order}
                department={isBodyShop ? 1 : 0}
                extents={[{type: extentType, editable: true, viewMode: viewMode, renderInside: renderInside}]}
                goBack={this.checkPopupGoBack.bind(this)}
                router={this.props.router}
              />
            </div>}
            {this.state.showEmail && this.renderSendEmail()}
          </Panel>
        </div>
      )
    }

    return (
      <div className={'pricecalculation__screen'}>
        <Header router={this.props.router} showBack headerButtonsGoBack={headerButtonsGoBack} />
        <div className='pricecalculation__inner clearfix'>
          {doRenderCarArea && renderCarArea()}
          {doRenderExtrasArea && renderExtrasArea()}
          {doRenderExtentArea && renderExtentArea()}
          {(this.props.order.OrderType === 4) && this.renderOtherOrder()}
          {this.renderDraftDeliveryDatePopup()}
          {this.state.ShowExitConfirm === true &&
            <Confirm
              t={translation}
              renderText={() => confirmExitText}
              confirm={this.confirm}
              notConfirm={this.confirm.bind(this, true)}
              confirmText={() => translation('394')}
              notConfirmText={() => translation('13253')}
            />}
        </div>
      </div>
    )
  }

  confirm (not) {
    this.setState({
      ShowExitConfirm: false
    }, () => {
      if (not === true) {
        this.postCancel().then(() => {
          this.goBack(this.state.ShowExitConfirmClose === true)
        })
      }
      // as a simple fix for price calculation, it should just close the popup, and the user should click on the OK button
    })
  }

  checkPopupGoBack (close) {
    let showPopup = this.state.draftDeliveryChangePopup.originalDate !== this.state.draftDeliveryChangePopup.newDate
    if (showPopup) {
      this.setState({
        draftDeliveryChangePopup: {
          ...this.state.draftDeliveryChangePopup,
          show: this.state.draftDeliveryChangePopup.originalDate !== this.state.draftDeliveryChangePopup.newDate
        }
      })
    } else if ((this.props.order.IsDraft === true || this.props.order.OrderType + '' === '1') && !this.props.price.IsAfterEvaluation) {
      this.goBack(close)
    } else if (this.props.price.RequireShopApproval === true) {
      this.setState({
        ShowExitConfirm: true,
        ShowExitConfirmAction: close === true
      })
    } else {
      this.goBack(close)
    }
  }
  goBack (close) {
    if (close === true) {
      let routeItem = window.LocalstorageStack.findFirst(['/workscreen', '/orders'])
      if (routeItem !== null) {
        if (routeItem.pathname === '/orders') {
          this.clearData()
          this.clearEvents()
          this.props.router.replace(routeItem.pathname + '?orderid=' + this.props.price.OrderId)
        } else {
          this.clearData()
          this.clearEvents()
          this.props.router.replace(routeItem.pathname)
        }
      } else {
        this.clearData()
        this.clearEvents()
        this.props.router.goBack()
      }
    } else {
      this.clearData()
      this.clearEvents()
      let routeItem = window.LocalstorageStack.top()
      // Fix for Edge, did cache some price calculations on workcard, and has to navigate insted of goBack
      if (routeItem !== null && routeItem.pathname === '/orders/' + this.props.price.OrderId) {
        this.props.router.push({
          pathname: '/orders/' + this.props.price.OrderId
        })
      } else {
        this.props.router.goBack()
      }
    }
  }
  renderOtherOrder () {
    const onInputChangeOtherOrder = (e) => {
      this.setState({
        manual: {
          ...this.state.manual,
          [e.target.name]: e.target.value
        }
      })
    }
    const saveOrder = () => {
      let data = {
        OrderId: this.props.order.Id,
        Price: parseFloat(reverseFormatCurrency(this.state.manual.Price)),
        Environment: parseFloat(reverseFormatCurrency(this.state.manual.Environment)),
        OtherTitle: this.state.manual.OtherTitle,
        OtherDescription: this.state.manual.OtherDescription
      }
      this.props.updateOtherOrderPrice(data).then((res) => {
        this.setState({
          manual: {
            Price: (formatCurrency(res.data.Price) === '0,00' || formatCurrency(res.data.Price) === '0.0') ? '' : formatCurrency(res.data.Price),
            Environment: (formatCurrency(res.data.Environment) === '0,00' || formatCurrency(res.data.Environment) === '0.0') ? '' : formatCurrency(res.data.Environment),
            OtherTitle: res.data.OtherTitle === null ? '' : res.data.OtherTitle,
            OtherDescription: res.data.OtherDescription === null ? '' : res.data.OtherDescription
          }
        })
        let routeItem = window.LocalstorageStack.findFirst(['/workscreen', '/orders'])
        if (routeItem !== null) {
          if (routeItem.pathname === '/orders') {
            this.props.router.replace(routeItem.pathname + '?orderid=' + this.props.price.OrderId)
          } else {
            this.props.router.replace(routeItem.pathname)
          }
        } else {
          this.props.router.goBack()
        }
      })
    }

    return (
      <Row>
        <Col>
          <Panel title={translation('73')}>
            <Text labelText={translation('1206')} name='OtherTitle' value={this.state.manual.OtherTitle} onChange={onInputChangeOtherOrder} />
            <Text labelText={translation('641')} name='Price' value={this.state.manual.Price} placeholder='0,00' onChange={onInputChangeOtherOrder} />
            <Text labelText={translation('13339')} name='Environment' value={this.state.manual.Environment} placeholder='0,00' onChange={onInputChangeOtherOrder} />
            <Textarea labelText={translation('1021')} name='OtherDescription' value={this.state.manual.OtherDescription} onChange={onInputChangeOtherOrder} />
            <Button onClick={saveOrder} labelText={translation('791')} />
          </Panel>
        </Col>
      </Row>
    )
  }

  renderDraftDeliveryDatePopup () {
    if (!this.state.draftDeliveryChangePopup.show) return null
    if (this.props.auth.user.CustomerId === '-1' && this.state.draftDeliveryChangePopup.show) {
      this.goBack()
    } else {
      const onSave = (date) => {
        this.setState({
          draftDeliveryChangePopup: {
            ...this.state.draftDeliveryChangePopup,
            newDate: date,
            oldDate: date,
            show: false
          }
        }, () => {
          this.saveDelivery()
        })
      }
      return (
        <DeliveryDateChangeModal
          isCustomerDraft
          show={this.state.draftDeliveryChangePopup.show}
          onClose={onSave.bind(this)}
          onSave={onSave.bind(this)}
          oldDate={this.state.draftDeliveryChangePopup.originalDate}
          newDate={this.state.draftDeliveryChangePopup.newDate} />
      )
    }
  }

  saveDelivery () {
    let editedBookingTime = {
      Department: this.props.auth.departmentType,
      BookingTimeType: BookingTimesSectionType.Delivery,
      OrderId: this.props.order.Id,
      Date: this.state.draftDeliveryChangePopup.newDate,
      Time: renderTimeOnly(this.state.draftDeliveryChangePopup.newDate)
    }

    this.props.saveBookingTime(editedBookingTime).then((res) => {
      this.goBack()
    }, () => {
      window.toastr.error(translation('13404'), translation('216'))
      this.goBack()
    })
  }
}
PriceCalculation.propTypes = {
  getPriceInformations: React.PropTypes.func.isRequired,
  getPriceInformation: React.PropTypes.func.isRequired,
  // getPrices: React.PropTypes.func.isRequired,
  updatePrices: React.PropTypes.func.isRequired,
  getOrder: React.PropTypes.func.isRequired,
  triggerPopup: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    price: state.price.price,
    order: state.orders.order,
    carSizes: state.common.enums.carSizes,
    carSelectedParts: state.price.carSelectedParts
  }
}

export default connect(mapStateToProps, {
  getPriceInformations,
  getPriceInformation,
  // getPrices,
  updatePrices,
  getOrder,
  triggerPopup,
  getCustomer,
  updateOtherOrderPrice,
  getRejectedEvaluations,
  setCarParts,
  setCarSelectedParts,
  setPageTitle,
  saveBookingTime
})(PriceCalculation)



// WEBPACK FOOTER //
// ./src/app/pages/PriceCalculation/index.js